// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"369":"eaed5544","674":"bd86b1b9"}[chunkId] + ".chunk.css";
};